import * as types from './types'
import { getMedia } from 'utils'
import { NOTIFICATIONS } from 'common/endpoints'
import { NOTIFICATION_TYPES } from 'common/constants'
import { timeoutDelay } from 'config/notifications.config'

export const fetchNotifications = () => ({
  type: types.FETCH_NOTIFICATIONS,
  meta: {
    url: NOTIFICATIONS.GET,
    params: { filter: NOTIFICATION_TYPES.join(',') },
    onSuccess: (data, dispatch) => setTimeout(() => dispatch(timeoutNotifications()), timeoutDelay),
  },
})

export const consumeNotification = notification => ({
  type: types.CONSUME_NOTIFICATION,
  notification,
  meta: { method: 'PUT', url: notification.id < 0 ? '' : NOTIFICATIONS.consume(notification) },
})

export const seeNotifications = () => ({ type: types.SEE_NOTIFICATIONS })

export const hideNotifications = () => ({ type: types.HIDE_NOTIFICATIONS })

export const timeoutNotifications = () => ({ type: types.TIMEOUT_NOTIFICATIONS })

export const flirtPopup = account => ({
  type: types.FLIRT_POPUP,
  notification: {
    id: -1,
    fake: true,
    typeAlias: types.FLIRT_POPUP,
    sender: { ...account, media: getMedia(account, 'flirt') },
    timestamp: Date.now(),
  },
})
